const validate = () => {
    const sendBtn = document.querySelector('#send');
    const inputName = document.querySelector('input[name="name"]');
    const inputEmail = document.querySelector('input[name="email"]');
    const inputAgree = document.querySelector('input[name="agree"]');

    const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    
    function isInputNameValid(value) {
        return (value.length >= 2);
    }
    
    function isInputEmailValid(value) {
        return (EMAIL_REGEXP.test(value) && value.length > 7);
    }

    function isInputAgreeValid(value) {
        return value.checked;
    }

    function disableBtn() {
        if(isInputEmailValid(inputEmail.value) && isInputNameValid(inputName.value) && isInputAgreeValid(inputAgree)) {
            sendBtn.removeAttribute('disabled');
        } else {
            sendBtn.setAttribute('disabled', true);
        }
    }
    disableBtn();

    function validateInputs(nameOfInput, validTest) {
        function onInput() {
            if(validTest(nameOfInput.value)) {
                nameOfInput.classList.remove('error');
            } else {
                nameOfInput.classList.add('error');
            }
        }
        nameOfInput.addEventListener('input', onInput);
        nameOfInput.addEventListener('input', disableBtn);
    }

    validateInputs(inputName, isInputNameValid);
    validateInputs(inputEmail, isInputEmailValid);
    validateInputs(inputAgree, isInputAgreeValid);
}

export default validate;